import { graphql } from "@server/gql";

export default graphql(/* GraphQL */ `
  query CheckoutDeliveryByIds(
    $locale: String!
    $ids: [String] = null
    $preview: Boolean
  ) {
    checkoutDeliveryCollection(
      where: { id_in: $ids }
      locale: $locale
      limit: 50
      preview: $preview
    ) {
      items {
        ...checkoutDelivery
      }
    }
  }
`);
